import meCode from '@/assets/images/me-code.png';
import meDesign from '@/assets/images/me-design.png';
import meDraw from '@/assets/images/me-draw.png';

export const crafts = [
  {
    id: 'code',
    word: 'code',
    image: meCode,
    accent: '#f59e0b',
    blurb: 'I build fast, accessible web apps with clean, maintainable code.',
  },
  {
    id: 'design',
    word: 'design',
    image: meDesign,
    accent: '#af0151',
    blurb: 'I shape interfaces and design systems that feel effortless to use.',
  },
  {
    id: 'draw',
    word: 'draw',
    image: meDraw,
    accent: '#16a34a',
    blurb: 'Away from the keyboard, I paint, sketch and letter by hand.',
  },
];
